// src/stores/constants.js
export const COOUNTER_INTERVAL = 1000; // 1 segundo
export const VERIFY_TIME_SESSION_INTERVAL = 30000; // 30 segundos
const STATUS_RESPONSE = {
    STATUS_SUCCESS: 'success',
    STATUS_ERROR : 'error',
    STATUS_CONFLICT : 'conflict',
    STATUS_ONLINE : 'online',
    STATUS_TIMEOUT : 'timeout',
    STATUS_TIMEOUT_SYNC : 'timeout_sync',
    STATUS_OFFLINE : 'offline',
    STATUS_AUTHORIZE : 'authorize',
    STATUS_AUTHORIZING : 'authorizing',
    STATUS_BLOCKED : 'blocked',
}

export default STATUS_RESPONSE;